import { useState, useEffect } from "react";
import { customFetch } from "utils/customFetch";

const useFetch = (url, options, cacheValidMinutes = 0, trigger) => {
	const [response, setResponse] = useState(null);
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);
	useEffect(() => {
		const abortController = new AbortController();
		const signal = abortController.signal;
		const doFetch = async () => {
			setError(null);
			setLoading(true);
			try {
				const json = await customFetch(
					url,
					options || {},
					cacheValidMinutes,
					signal
				);
				if (!signal.aborted) {
					setResponse(json);
				}
			} catch (e) {
				if (e && e.name === 'AbortError') {
					return;
				}
				console.error(e);
				if (!signal.aborted) {
					setResponse(null);
					setError(e);
				}
			} finally {
				if (!signal.aborted) {
					setLoading(false);
				}
			}
		};
		if (url) {
			doFetch();
		}
		return () => {
			abortController?.abort();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [trigger]);
	return { response, error, loading };
};
export default useFetch;
